import { ADD_WORKER_TO_IMPORTANT_TASK } from "../../../../enums/Request/request.types";

export const addWorkerToImportantTaskAction = () => {
    return {
        type: ADD_WORKER_TO_IMPORTANT_TASK,
    };
};